

















import Bauble from '@/components/announcementbar/christmas-calendar/subcomponents/Bauble.vue';
import ChristmasCalendarButton from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarButton.vue';
import Vue from 'vue';

export default Vue.extend({
  name: `ChristmasCalendarMobileView`,
  components: { Bauble, ChristmasCalendarButton },
  props: {
    day: {
      required: true,
      type: Number,
    },
    title: {
      required: true,
      type: String,
    },
  },
});
